
import { useSelector,useDispatch } from 'react-redux'
import  IdentCheck  from './IdentCheck';
import  DocRead  from './DocRead';
import SignatureDoc from './SignatureDoc'
import EndMeeting from './EndMeeting';
import StapelSignatur from './StapelSignatur';
import DocConvertProgress from './helper/DocConvertProgress';
import { setdisplaywidth, handleonlinebar, close_vk_extern_modal,clear_playsound, unset_showmeeting, setsetupnotar, set_Acc_InProgress } from '../slice/mainslice';
import { LayoutColumns, LayoutRows, FileInfo } from 'tabler-icons-react';

import SetupMeeting from './SetUpMeeting';
import { UpateMeetingDocs } from './UpateMeetingDocs';


import { Camera,Article, Pencil, HeartHandshake, Logout, Settings , Video, Refresh, User ,FileText,Stack2   } from 'tabler-icons-react';
import { Accordion, rem, Title, Grid, createStyles, Group, Indicator, Avatar, ActionIcon,Modal, Button, Text, Tooltip, Switch, Alert, Tabs   } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';

import { DocReadCount } from './helper/DocReadCount';
import { IdentCount } from './helper/IdentCount';
import { DocSignCountOverview } from './helper/DocSignCountOverview';
import ClientChangeLanguage from '../helperforall/ClientChangeLanguage';
import AccordionChangeLanguage from '../helperforall/AccordionChangeLanguage';
import intl from 'react-intl-universal';
import ViewAllDoc from './ViewAllDoc';


const useStyles = createStyles((theme) => ({
  padtop10: {
    paddingTop: `10px`,
  },
  padtopFlag10: {
    paddingTop: `10px`,
    cursor: `pointer`,
  },
  padtop20: {
    paddingTop: `20px`, 
  },
  aktiv: {
    backgroundColor: `#ffffff`,
    borderLeft: `5px solid ${theme.colors.green[6]}`,
    paddingLeft: `5px`,
  }, 
  textsize: {
    fontSize: rem('16px'),
    [theme.fn.smallerThan('lg')]: {
      fontSize: rem('10px'),
    },
  },
  itemTitle: {
    fontSize: rem('16px'),
    [theme.fn.smallerThan('lg')]: {
      fontSize: rem('12px'),
    },
  },

 
}));


const ToolsView = () => {
  const { classes } = useStyles();
  const dispatch = useDispatch()
  const szeneflow = useSelector((state: any) => state.user.meetingszenen)
  const meuser = useSelector((state: any) => state.user.meuser)
  const meetinguser = useSelector((state: any) => state.user.meetinguser)
  const meetinginfo = useSelector((state: any) => state.user.meetinginfo)
  const setupnotar = useSelector((state: any) => state.user.setupnotar)

  const showdoc = useSelector((state: any) => state.user.showmeetingdocs)
  const showsigndoc = useSelector((state: any) => state.user.showsignmeetingdocs)

  const accinProgress = useSelector((state: any | null) => state.user.accinProgress)
  const screenshots = useSelector((state: any) => state.user.identscreenshots)
  const notarhastosign = useSelector((state: any) => state.user.notarhastosign)

  const docinprogress = useSelector((state: any) => state.user.docsconvertinprogress)
  const showonlinebar = useSelector((state: any) => state.user.showonlinebar)

  const externclosevk = useSelector((state: any) => state.user.externclosevk)

  // StapelUser
  const stapeluser = useSelector((state: any) => state.user.userhavetostapelsigndocs) || [];

  //Docs zum Unterschreiben
  const signuser = useSelector((state: any) => state.user.userhavetosigndocs) || [];

  // Unterschriften offen oder geschlossen
  const signtabopen = useSelector((state: any) => state.user.signtabopen)

  // alle Documente
  const docall = useSelector((state: any) => state.user.meetingdocs)

  const [opened, setopenNotar] = useState(setupnotar);
  const [logoutopened, setLogoutopened] = useState(false);
  const [udateopened, setUdateopened] = useState(false);
  const [identdivheight, setIdentdivheight] = useState(0);
  const [readdivheight, setReaddivheight] = useState(0);
  const [signdivheight, setSigndivheight] = useState(0);


  const [value, setValue] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<string | null>(() => {
  // Beim ersten Laden aus dem Speicher lesen
  return localStorage.getItem("savedTab") || "info";
});

  const [savedocs, setSavedocs] = useState(true);

  const playsound = useSelector((state: any) => state.user.playsound)
  const [sound, setSound] = useState<HTMLAudioElement | null>(null);


  const identRef = useRef<HTMLDivElement>(null);
  const readRef = useRef<HTMLDivElement>(null);
  //const signRef = useRef<HTMLDivElement>(null);


  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = Math.abs(offsetMinutes) / 60;
  const offsetSign = offsetMinutes < 0 ? '+' : '-';
  const formattedOffset = `${offsetSign}${String(offsetHours)}`;

   //console.log("value:",value)
   //console.log("accinProgress:",accinProgress)


useEffect(() => {


    if(value === null && accinProgress === "UTAB"){
    setValue("Unterschriften")
    dispatch(set_Acc_InProgress(""))
    }

     if(value === null && accinProgress === "Unterschriften"){
    setValue("Unterschriften")
    //dispatch(set_Acc_InProgress(""))
    }


  if (value === "Unterschriften" && localStorage.getItem("savedTab") === ""){
    // Alten Speicherstand entfernen, um sauber mit "standart" zu starten
    //localStorage.removeItem("savedTab");
    console.log("activeTab inside:",localStorage)
    if (stapeluser.length === 0 && signuser.length === 0){
      setActiveTab("info");
    } else {
      if (signuser.length >= 1 && stapeluser.length === 0){
        setActiveTab("standart");
      }
      if (stapeluser.length >= 1 && signuser.length === 0){
       setActiveTab("stapel");
      }
      if (stapeluser.length >= 1 && signuser.length >= 1){
       setActiveTab("standart");
      }
    }
  }
}, [value, accinProgress,stapeluser,signuser]);

useEffect(() => {
  if (activeTab !== null) {
    localStorage.setItem("savedTab", activeTab);
  }
}, [activeTab]);

//console.log("accinProgress:",accinProgress)
//console.log("value:",value)

  useEffect(() => {
    const audio = new Audio();
    audio.src = process.env.PUBLIC_URL + '/info.mp3'
    setSound(audio);
  }, []);


  useEffect(() => {
    if (setupnotar) {
      setopenNotar(true);
    }
  }, [setupnotar]);


  useEffect(() => {
    if (playsound && sound && !opened){
      sound.play();
      dispatch(clear_playsound())
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sound,playsound,opened]);


  useEffect(() => {
    

    // Get Init Screenshotdaten wenn diese Leer sind 
    if (screenshots.length === 0){
      const getscreenshotspayload = {
        drnId: meetinginfo.drnId
      }
      dispatch({ type: 'SIGNALR_GETINITSCREENSHOT', payload: getscreenshotspayload });
    }

    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        if (entry.target === identRef.current) {
          const { height } = entry.contentRect;
          setIdentdivheight(height);
         // console.log('Height changed:', height, 'px');
        }
        if (entry.target === readRef.current) {
          const { height } = entry.contentRect;
          setReaddivheight(height);
         // console.log('Height changed:', height, 'px');
        }
        /*if (entry.target === signRef.current) {
          const { height } = entry.contentRect;
          setSigndivheight(height);
          //console.log('Height changed:', height, 'px');
        }*/
       
      }
    });


    if (identRef.current) {
      observer.observe(identRef.current);
    }
    if (readRef.current) {
      observer.observe(readRef.current);
    }
   /* if (signRef.current) {
      observer.observe(signRef.current);
    }*/


    return () => {
      if (identRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(identRef.current);
      }
      if (readRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(readRef.current);
      }
      /*if (signRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(signRef.current);
      } */

    };
  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (externclosevk && !logoutopened) {
    setLogoutopened(true)
  }


  
     let a = meuser.lastName.substring(0,1)
     let b = meuser.firstName.substring(0,1)
     let initialen = a + b
     let fullname = meuser.lastName + " " + meuser.firstName

     const handleopenNotar = () => {
      let newvalue = !opened
       setopenNotar(newvalue)  
       dispatch(setsetupnotar(newvalue));
    };

  
    const handleLogout = () => {
      setLogoutopened(true);
    };

    const handleLogoutclose = () => {
      setSavedocs(true);
      setLogoutopened(false);
    };
  

    const handleLogoutYesClick = () => {
      sentlogoutcommand()
      localStorage.removeItem("savedTab");
      dispatch(close_vk_extern_modal());
      handleLogoutclose();
    };
  
    const handleLogoutNoClick = () => {
      dispatch(close_vk_extern_modal());
      handleLogoutclose();
    };   

    const sentlogoutcommand = () => {
      const handlelogoutpayload = {
        drnId: meetinginfo.drnId,
        command: "closevideopopup"   
      }; 
      // Dispatch Command um den Archivupload der Dokumente zu DRN auszulösen
     /*f (savedocs){ */
          const sentzippayload = {
            drnId: meetinginfo.drnId,
            timezone: formattedOffset,
          }; 
          dispatch({ type: 'SIGNALR_SENDCLOSEMEETING_ZIPARCHIV', payload: sentzippayload });
    /* } */
    dispatch({ type: 'SIGNALR_SENDCLOSEMEETING', payload: handlelogoutpayload });
  }




    const handleUpdateDocsopen = () => {
      setUdateopened(true);
    };

    const handleUpdateDocsclose = () => {
      setUdateopened(false);
    };


  







  const setcurrentszene = (newvalue:string) => {
      try {
        //console.log("accinProgress:",accinProgress)
        if (accinProgress !== ""){
          newvalue = accinProgress
        }

        if(value !== ""){  
            const szenedata = szeneflow.filter((obj: { sceneName: any; }) => {
            return obj.sceneName === newvalue
        });

      const changeszenepayload = {
          meetingId: meetinginfo.id,
          drnId: meetinginfo.drnId,
          scenarioId: szenedata[0].scenarioId,
          sceneId: szenedata[0].sceneId
        }  

      dispatch({ type: 'SIGNALR_CHANGECURRENTSZENE', payload: changeszenepayload });
      
      // Reset Protokoll VieW
      dispatch(unset_showmeeting())
 
      
      //console.log("Szenenwechsel zu:",newvalue)
      setValue(newvalue)
        } else {
          throw new Error("Szenenwechsel Value ist Null");
        }
      }
      catch (e) {
        // Fehler entdeckt
        //console.log(e);
        }
      }



  // Status Abzeige Online UserMe ()
  const meuserstatus = meetinguser.filter((obj: { id: any; }) => {
    return obj.id === meuser.id
    });
  
  let userstatuscolor = "red";
  // Handle wenn User hat noch keinen Status
  if(meuserstatus[0].meetingParticipantStatus === null) {
    userstatuscolor = "red";
  }
  if(meuserstatus[0].meetingParticipantStatus === "LeftMeeting") {
    userstatuscolor = "red";
  }
  if(meuserstatus[0].meetingParticipantStatus === "InMeeting") {
    userstatuscolor = "green";
  }

 // console.log(szeneflow)
   


  const szenen = (szeneflow || []).map((szene:any, index:any) => {
      let icon 
      if (szene.sceneId === 1){
        icon = <HeartHandshake size={rem(40)} color="green" />
      }
      if (szene.sceneId === 2){
        icon = <Camera size={rem(40)} color="green" />
      }
      if (szene.sceneId === 3){
        icon = <Article size={rem(40)} color="green" />
      }
      if (szene.sceneId === 4){
        icon = <Pencil size={rem(40)} color="green" />
      }
      if (szene.sceneId === 5){
        icon = <Logout size={rem(40)} color="green" />
      }


    
  
    let disabled = false
    if (accinProgress !== ""){
      if (accinProgress !== szene.sceneName){
          //disabled = true
      }
    }



       
    //console.log("value", value)
    //console.log("szene.sceneName", szene.sceneName)
    return(
    
 
   <div key={szene.sceneName}>
  {szene.sceneId != 1 &&      
  <Accordion.Item value={szene.sceneName}>
      {szene.sceneId != 3 &&
      <Accordion.Control icon={icon} disabled={disabled} className={classes.itemTitle}>
           <Group>
            <AccordionChangeLanguage sceneId={szene.sceneId} />
              {szene.sceneId === 24 /*2 zeigt an */ &&
                <IdentCount />
              }
              {szene.sceneId === 13 &&
                <DocReadCount />
              }
              {szene.sceneId === 44 /*4 zeigt an */ &&
                <DocSignCountOverview />
              }
        </Group>
    </Accordion.Control>
      }
        <Accordion.Panel>
          {szene.sceneId === 2 &&
           <div ref={identRef} className={classes.aktiv}>
            <IdentCheck sceneId={szene.sceneId} scenarioId={szene.scenarioId} divheight={identdivheight}/>
          </div>
          }
          {szene.sceneId === 13 &&
           <div ref={readRef} className={classes.aktiv}>
            <DocRead divheight={readdivheight} />
          </div>
          }
          {szene.sceneId === 4 &&
          <div  className={classes.aktiv}>
          {docall?.length > 0 &&  
          <Tabs value={activeTab} onTabChange={setActiveTab} >
                <Tabs.List grow>
                  {signuser?.length > 0 &&
                  <Tabs.Tab value="standart" icon={<FileText size="0.8rem" />}>{intl.get('TOOLSVIEW_TAB_STANDARD')}</Tabs.Tab>
                  }
                  {stapeluser?.length > 0 &&
                  <Tabs.Tab value="stapel" icon={<Stack2 size="0.8rem" />}>{intl.get('TOOLSVIEW_TAB_STAPEL')}</Tabs.Tab>
                  }
                  <Tabs.Tab value="info" icon={<FileInfo size="0.8rem" />}>{intl.get('TOOLSVIEW_TAB_ALLDOCUMENTS')}</Tabs.Tab>
                </Tabs.List>
                 {signuser?.length > 0 &&
                <Tabs.Panel value="standart" pt="xs">
                      <SignatureDoc sceneId={szene.sceneId} scenarioId={szene.scenarioId} divheight={signdivheight}/>
                </Tabs.Panel>
                }
                {stapeluser.length > 0 &&
                <Tabs.Panel value="stapel" pt="xs">
                   <StapelSignatur sceneId={szene.sceneId} scenarioId={szene.scenarioId} divheight={signdivheight} />
                </Tabs.Panel>
                }
                <Tabs.Panel value="info" pt="xs">
                   <ViewAllDoc sceneId={szene.sceneId} scenarioId={szene.scenarioId} divheight={signdivheight}/>
                </Tabs.Panel>
                </Tabs>
            }
            {stapeluser.length === 1125 &&
              <SignatureDoc sceneId={szene.sceneId} scenarioId={szene.scenarioId} divheight={signdivheight}/>
            }
          </div>
          }
          {szene.sceneId === 5 &&
            <EndMeeting sceneId={szene.sceneId} scenarioId={szene.scenarioId}/>
          }
        </Accordion.Panel>
      </Accordion.Item>
  }
      </div>
      
    )
    
  });

  return (
    <>  
    <Grid >

      <Grid.Col xs={7}  md={7} lg={7}>
        <Group position="left" className={classes.padtop10}>
        <Indicator inline size={10} offset={2} position="bottom-end" color={userstatuscolor} withBorder >
            <Avatar color="blue" variant="filled" radius="xl" size="sm">{initialen}</Avatar>
        </Indicator>
       <span className={classes.textsize}><b>{fullname}</b> </span>
       </Group> 
    </Grid.Col>
      <Grid.Col xs={5} md={5} lg={5}>
      <Group position="right" spacing="xs" className={classes.padtop10}>
      {!showonlinebar && 
      <Tooltip label={intl.get('TOOLSVIEW_SHOWONLINE')} multiline={true}><span><User size={25} strokeWidth={1} color={'black'}  onClick={() => dispatch(handleonlinebar(true))}/></span></Tooltip>
      }
      <Tooltip label={intl.get('TOOLSVIEW_UPDATE')} multiline={true}><span><Refresh size={25} strokeWidth={1} color={'black'}  onClick={handleUpdateDocsopen}/></span></Tooltip>
      <Tooltip label={intl.get('TOOLSVIEW_SETTING')} multiline={true}><span><Settings size={25} strokeWidth={1} color={'black'} onClick={handleopenNotar}/></span></Tooltip>
      <Tooltip label={intl.get('TOOLSVIEW_LOGOUT')} multiline={true}><span> <Logout size={25} strokeWidth={1} color={'black'} onClick={handleLogout}/></span></Tooltip>
        </Group>
      </Grid.Col>
    </Grid>
    <hr />
    <Grid >
      <Grid.Col xs={10}  md={10}>
      <Group>
        <Video size={rem(30)} color="gray" />
        <Title order={5} className={classes.textsize}> {meetinginfo.title}</Title>
      </Group>
    </Grid.Col>
      <Grid.Col xs={2} md={2}>
      <Group position="right" className={classes.padtopFlag10}>
            <ClientChangeLanguage />
        </Group>
      </Grid.Col>
    </Grid>
    
    <hr />


  <Accordion variant="contained" value={value} defaultValue="Identitätsfeststellung"  onChange={setcurrentszene}>
      {szenen}
  </Accordion>

   {docinprogress && docinprogress.length > 0 &&
    <>
    <div className={classes.padtop20}>
      <DocConvertProgress />
    </div>
    </>
   } 
    {showdoc.resourceId !== undefined  && notarhastosign &&
                <>
                <hr />
                <Title order={3}>{intl.get('TOOLSVIEW_LAYOUT_HEAD')}</Title>
                <Group position="left">
                <ActionIcon variant="outline" size="xl" aria-label="Settings" onClick={() => dispatch(setdisplaywidth(1))}>
                      <LayoutRows style={{ width: '70%', height: '70%' }}   />
                </ActionIcon>
                <ActionIcon variant="outline" size="xl" aria-label="Settings" onClick={() => dispatch(setdisplaywidth(2))}>
                      <LayoutColumns style={{ width: '70%', height: '70%' }}   />
                </ActionIcon>
                </Group>
                </>
    }
    {showsigndoc.resourceId !== undefined  && notarhastosign &&
                <>
                <hr />
                <Title order={3}> {intl.get('TOOLSVIEW_LAYOUT_HEAD')}</Title>
                <Group position="left">
                <ActionIcon variant="outline" size="xl" aria-label="Settings" onClick={() => dispatch(setdisplaywidth(1))}>
                      <LayoutRows style={{ width: '70%', height: '70%' }}   />
                </ActionIcon>
                <ActionIcon variant="outline" size="xl" aria-label="Settings" onClick={() => dispatch(setdisplaywidth(2))}>
                      <LayoutColumns style={{ width: '70%', height: '70%' }}   />
                </ActionIcon>
                </Group>
                </>
    }


  <Modal 
     opened={opened} 
     onClose={handleopenNotar} 
     closeOnClickOutside={false}
     withCloseButton={true}
     size="99%"
     transitionProps={{ transition: 'fade', duration: 200 }}
     styles={(theme) => ({ 
       inner:{
         paddingTop: `1vw !important`,
         paddingBottom: `1vw !important`,
         paddingLeft: `1vw !important`,
         paddingRight: `1vw !important`,
       }
     })}
     >
       <SetupMeeting close={handleopenNotar}/>
  </Modal>


  <Modal 
     title={intl.get('TOOLSVIEW_MODAL_DOCUPDATE')}
     size="xl"
     
     opened={udateopened} 
     onClose={handleUpdateDocsclose} 
     closeOnClickOutside={false}
     withCloseButton={true}
     >
       <UpateMeetingDocs handleUpdateDocsclose={handleUpdateDocsclose}/>
  </Modal>


  <Modal
        title=""
        opened={logoutopened}
        onClose={handleLogoutclose}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        zIndex={10000}
        >
          <Text>{intl.get('TOOLSVIEW_MODAL_ENDMEETING_TEXT')} </Text>
          {/*
          <Alert  color="gray">
            <Switch size="md" color="green" label="Ablage des Protokollpakets" onLabel="Ja" offLabel="Nein"   checked={savedocs}  onChange={() => setSavedocs(!savedocs)} /> 
         </Alert>
          */}
          
          <hr />
          
          <Grid>
          <Grid.Col span={6}>
            <Button fullWidth color="green" onClick={handleLogoutYesClick}>{intl.get('DIALOG_BUTTON_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button fullWidth color="gray" variant="light" onClick={handleLogoutNoClick}>{intl.get('DIALOG_BUTTON_NO_CLOSE')}</Button>
            </Grid.Col>
          </Grid>
         
      </Modal> 
    
   
    </>
  );
}


export default ToolsView ;